<template>
    <nav class="pagination is-centered is-rounded" role="navigation" aria-label="pagination">

        <div class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6">

  <div class="flex-1 sm:flex sm:items-center sm:justify-between">
    <div>
      <p class="text-sm leading-5 text-gray-700">
        Risultati da
        <span class="font-medium">{{(pagination.current_page - 1) * pagination.per_page + 1}}</span>
        a
        <span class="font-medium">{{lastItemShowed}}</span>
        di
        <span class="font-medium">{{pagination.total}}</span>
      </p>
    </div>
    <div>
      <nav class="relative z-0 inline-flex shadow-sm">
        <a @click.prevent="changePage(1)" class="relative inline-flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 cursor-pointer rounded-l-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500" aria-label="Previous">
          Inizio
        </a>
        <a  v-for="page in pages" :key="page" :class="isCurrentPage(page) ? 'bg-indigo-500 text-white hover:bg-indigo-600' : 'text-gray-700'" @click.prevent="changePage(page)" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 transition duration-150 ease-in-out bg-white border border-gray-300 cursor-pointer focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700">
          {{page}}
        </a>
        
        <a @click.prevent="changePage(pagination.last_page)" class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out bg-white border border-gray-300 cursor-pointer rounded-r-md hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500" aria-label="Next">
          Fine
        </a>
      </nav>
    </div>
  </div>
</div>

    </nav>
</template>

<style>
    .pagination {
        margin-top: 40px;
    }
</style>

<script>
    export default {
        props: ['pagination', 'offset'],
        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },
            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                this.pagination.current_page = page;
                this.$emit('paginate', page);
            }
        },
        computed: {
            pages() {
                let pages = [];
                let from = this.pagination.current_page - Math.floor(this.offset / 2);
                if (from < 1) {
                    from = 1;
                }
                let to = from + this.offset - 1;
                if (to > this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                while (from <= to) {
                    pages.push(from);
                    from++;
                }
                return pages;
            },

            lastItemShowed(){
                return Math.min(this.pagination.current_page * this.pagination.per_page, this.pagination.total);
            }
        }
    }
</script>